import React, { useEffect, useMemo } from 'react';

import { useAccessToken } from 'Auth';

import {
  Iframe,
  Stack,
  NoResults,
  Card,
  CardHeader,
  Actions,
  Action,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
  Section,
  Link,
  OpenInNewIcon,
  FileDownloadIcon,
} from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';
import { defaultBaseURL } from 'api';

const Attachments = ({ data = [] }) => {
  const getAccessToken = useAccessToken();
  const [accessToken, setAccessToken] = useMountedState();
  const [selectedAttachment, setSelectedAttachment] = useMountedState(null);

  useEffect(() => {
    if (data.length) {
      setSelectedAttachment(data[0]);
    }
  }, [data]);

  useEffect(() => {
    getAccessToken().then(setAccessToken);
  }, []);

  const handleAttachmentChange = (_e, value) => {
    data.forEach(async (attachment) => {
      if (attachment.value === value) {
        setSelectedAttachment(attachment);
      }
    });
  };

  const selectedAttachmentSrc = useMemo(() => {
    if (!selectedAttachment) {
      return null;
    }
    return selectedAttachment.src
      ? selectedAttachment.src
      : `${defaultBaseURL}/api/io/${selectedAttachment.id}/download`;
  }, [selectedAttachment]);

  return (
    <React.Fragment>
      {data.length && selectedAttachment && accessToken ? (
        <Stack spacing={3}>
          {data.length !== 1 ? (
            <ToggleButtonGroup
              onChange={handleAttachmentChange}
              value={selectedAttachment.value}
            >
              {data?.map((opt) => {
                return (
                  <ToggleButton value={opt.value} style={{ minWidth: 78 }}>
                    {opt.label}
                  </ToggleButton>
                );
              })}
            </ToggleButtonGroup>
          ) : null}
          {selectedAttachment.withPreview ? (
            <Iframe
              src={`${selectedAttachmentSrc}?access_token=${accessToken}`}
              width={'100%'}
              height={'100vh'}
            />
          ) : selectedAttachment.value === 0 ? (
            <Section title={'Agreement'}>
              <Card elevation={6}>
                <CardHeader
                  title={
                    <Link href={selectedAttachmentSrc} target={'_blank'}>
                      {selectedAttachment.name || selectedAttachmentSrc}
                    </Link>
                  }
                  action={
                    <Actions>
                      <Action
                        icon={<OpenInNewIcon />}
                        label={'Open in new tab'}
                        onClick={() => {
                          window.open(`${selectedAttachmentSrc}`, '_blank');
                        }}
                      />
                    </Actions>
                  }
                />
              </Card>
            </Section>
          ) : (
            <Stack spacing={3}>
              <Alert severity={'info'}>
                Browsing .docx files is not supported
              </Alert>
              <Card elevation={6}>
                <CardHeader
                  title={selectedAttachment.name || selectedAttachmentSrc}
                  action={
                    <Actions>
                      <Action
                        icon={<FileDownloadIcon />}
                        label={'Download'}
                        onClick={() => {
                          window.location.assign(
                            `${selectedAttachmentSrc}?access_token=${accessToken}`
                          );
                        }}
                      />
                    </Actions>
                  }
                />
              </Card>
            </Stack>
          )}
        </Stack>
      ) : (
        <NoResults noResultsLabel={'No attachments'} inited={true} />
      )}
    </React.Fragment>
  );
};

export default Attachments;
